module.exports = __webpack_public_path__ + "img/9788996100140.e02388c2.jpg";